export default "__VITE_ASSET__BocInfBb__"